/**
 * Model reprezentujący pojedynczy parametr wyszukiwania (filtr) nałożony na tabelę DataGrid.
 * Agreguje nazwę filtrowanej kolumny oraz szukaną frazę.
 */
export class DataGridSearchField {

  /** Klucz pola, po którym następuje wyszukiwanie.
   * Ściśle powiązany z właściwością `columnKey` z modelu DataGridColumnDef.
   * Przykład: 'email', 'status', 'lastName'.
   */
  public fieldName: string;

  /** Szukana fraza, ciąg znaków lub wartość wpisana/wybrana przez użytkownika.
   */
  public searchTerm: string;

  constructor(fieldName: string, searchTerm: string) {
    this.fieldName = fieldName;
    this.searchTerm = searchTerm;
  }
}
